module.exports = __webpack_public_path__ + "img/1-4.3b386dec.svg";